// extracted by mini-css-extract-plugin
module.exports = {"tableView":"ParentsTable_tableView__3opr8"};